var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCustomer = function SvgCustomer(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1000 1000",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M896.9 999.9H191.3C118.4 999.9 59 940.5 59 867.6s59.3-132.3 132.3-132.3c24.4 0 44.1 19.7 44.1 44.1s-19.7 44.1-44.1 44.1-44.1 19.7-44.1 44.1 19.7 44.1 44.1 44.1h705.6c24.4 0 44.1 19.7 44.1 44.1 0 24.3-19.8 44.1-44.1 44.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M852.8 1.5H191.3C118.2 1.5 59 60.8 59 133.8v733.7l88.2-44.1h705.6c48.7 0 88.2-39.5 88.2-88.2V89.7c0-48.7-39.5-88.1-88.2-88.2M500 187.8c54 0 97.8 43.8 97.8 97.8S554 383.4 500 383.4s-97.8-43.8-97.8-97.8 43.8-97.8 97.8-97.8m176.1 413c0 10.8-8.8 19.6-19.6 19.6-.9-.1-1.7-.3-2.6-.5l.1.5H343.5c-10.8 0-19.6-8.8-19.6-19.6v-39.1c.1-54 43.8-97.8 97.8-97.8h156.5c54 .1 97.8 43.8 97.8 97.8v39.1z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCustomer);
export default ForwardRef;